import { InlineNotification } from '@carbon/react';

interface ZeroSumInfoBannerProps {
  isVisible: boolean;
}

/**
 * Info banner shown when no Eval 2.0 run is selected (zero-sum state).
 * Prompts the user to select an Eval 2.0 run to begin.
 *
 * @param {ZeroSumInfoBannerProps} props - Component props.
 * @return {JSX.Element | null} The info banner or null when hidden.
 */
export const ZeroSumInfoBanner = ({
  isVisible,
}: ZeroSumInfoBannerProps): JSX.Element | null => {
  if (!isVisible) return null;

  return (
    <InlineNotification
      kind="info"
      title="Welcome!"
      subtitle="Select an evaluation from Eval 2.0 to enable Calculate. You can adjust settings and add configurations first, if needed."
      lowContrast
      hideCloseButton
    />
  );
};
